var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-wrapper"},[_c('div',{staticClass:"layout plugin-blank_space",style:({height: ((_vm.config.height) + "px")})})])}
var staticRenderFns = []

export { render, staticRenderFns }